export const shareOnLinkedIn = (url, title = "") => {
  const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`
  window.open(shareUrl, "linkedin-share-dialog", "width=626,height=436")
}